(function () {
  "use strict";

  var e = {
    759: function _(e, t, r) {
      var _n,
          o = this && this.__extends || (_n = function n(e, t) {
        return (_n = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          }
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");

        function r() {
          this.constructor = e;
        }

        _n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r());
      }),
          a = this && this.__awaiter || function (e, t, r, n) {
        return new (r || (r = Promise))(function (o, a) {
          function s(e) {
            try {
              u(n.next(e));
            } catch (e) {
              a(e);
            }
          }

          function i(e) {
            try {
              u(n.throw(e));
            } catch (e) {
              a(e);
            }
          }

          function u(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
              e(t);
            })).then(s, i);
          }

          u((n = n.apply(e, t || [])).next());
        });
      },
          s = this && this.__generator || function (e, t) {
        var r,
            n,
            o,
            a,
            s = {
          label: 0,
          sent: function sent() {
            if (1 & o[0]) throw o[1];
            return o[1];
          },
          trys: [],
          ops: []
        };
        return a = {
          next: i(0),
          throw: i(1),
          return: i(2)
        }, "function" == typeof Symbol && (a[Symbol.iterator] = function () {
          return this;
        }), a;

        function i(a) {
          return function (i) {
            return function (a) {
              if (r) throw new TypeError("Generator is already executing.");

              for (; s;) {
                try {
                  if (r = 1, n && (o = 2 & a[0] ? n.return : a[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, a[1])).done) return o;

                  switch (n = 0, o && (a = [2 & a[0], o.value]), a[0]) {
                    case 0:
                    case 1:
                      o = a;
                      break;

                    case 4:
                      return s.label++, {
                        value: a[1],
                        done: !1
                      };

                    case 5:
                      s.label++, n = a[1], a = [0];
                      continue;

                    case 7:
                      a = s.ops.pop(), s.trys.pop();
                      continue;

                    default:
                      if (!((o = (o = s.trys).length > 0 && o[o.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                        s = 0;
                        continue;
                      }

                      if (3 === a[0] && (!o || a[1] > o[0] && a[1] < o[3])) {
                        s.label = a[1];
                        break;
                      }

                      if (6 === a[0] && s.label < o[1]) {
                        s.label = o[1], o = a;
                        break;
                      }

                      if (o && s.label < o[2]) {
                        s.label = o[2], s.ops.push(a);
                        break;
                      }

                      o[2] && s.ops.pop(), s.trys.pop();
                      continue;
                  }

                  a = t.call(e, s);
                } catch (e) {
                  a = [6, e], n = 0;
                } finally {
                  r = o = 0;
                }
              }

              if (5 & a[0]) throw a[1];
              return {
                value: a[0] ? a[1] : void 0,
                done: !0
              };
            }([a, i]);
          };
        }
      };

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = r(240),
          u = r(746),
          c = r(463),
          l = r(742),
          d = r(275),
          f = r(754),
          p = "0x70a08231",
          h = function (e) {
        function t(t) {
          var r = e.call(this) || this;
          return r._contractAddress = l.remove0x(t), r;
        }

        return o(t, e), t.prototype.generateErc20Transfer = function (e, t) {
          var r = u.padHexStart(l.remove0x(e), 32),
              n = u.padHexStart(l.remove0x(l.numberToHex(t)), 32);
          return [l.remove0x("0xa9059cbb"), r, n].join("").toLowerCase();
        }, t.prototype.sendTransaction = function (e) {
          return a(this, void 0, void 0, function () {
            var t, r;
            return s(this, function (n) {
              switch (n.label) {
                case 0:
                  return e.data ? [3, 4] : [4, this.getMethod("assertContractExists")(this._contractAddress)];

                case 1:
                  return n.sent(), [4, this.getMethod("getAddresses")()];

                case 2:
                  return t = n.sent(), [4, this.getBalance(t.map(function (e) {
                    return e.address;
                  }))];

                case 3:
                  if ((r = n.sent()).isLessThan(e.value)) throw new f.InsufficientBalanceError(t[0] + " doesn't have enough balance (has: " + r + ", want: " + e.value + ")");
                  e.data = this.generateErc20Transfer(c.addressToString(e.to), e.value), e.value = new d.BigNumber(0), e.to = l.ensure0x(this._contractAddress), n.label = 4;

                case 4:
                  return [2, this.getMethod("sendTransaction")(e)];
              }
            });
          });
        }, t.prototype.sendSweepTransaction = function (e, t) {
          return a(this, void 0, void 0, function () {
            var r, n, o;
            return s(this, function (a) {
              switch (a.label) {
                case 0:
                  return [4, this.getMethod("getAddresses")()];

                case 1:
                  return r = a.sent(), [4, this.getBalance(r.map(function (e) {
                    return e.address;
                  }))];

                case 2:
                  return n = a.sent(), o = {
                    to: e,
                    value: n,
                    data: null,
                    fee: t
                  }, [2, this.sendTransaction(o)];
              }
            });
          });
        }, t.prototype.getContractAddress = function () {
          return this._contractAddress;
        }, t.prototype.getBalance = function (e) {
          return a(this, void 0, void 0, function () {
            var t,
                r = this;
            return s(this, function (n) {
              switch (n.label) {
                case 0:
                  return [4, this.getMethod("assertContractExists")(this._contractAddress)];

                case 1:
                  return n.sent(), t = e.map(c.addressToString).map(l.ensure0x), [4, Promise.all(t.map(function (e) {
                    return r.getMethod("jsonrpc")("eth_call", {
                      data: [p, u.padHexStart(l.remove0x(e), 32)].join("").toLowerCase(),
                      to: l.ensure0x(r._contractAddress).toLowerCase()
                    }, "latest");
                  }))];

                case 2:
                  return [2, n.sent().map(function (e) {
                    return new d.BigNumber(l.hexToNumber(e));
                  }).filter(function (e) {
                    return !e.isNaN();
                  }).reduce(function (e, t) {
                    return e.plus(t);
                  }, new d.BigNumber(0))];
              }
            });
          });
        }, t;
      }(i.Provider);

      t.default = h;
    },
    175: function _(e, t, r) {
      var n = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.EthereumErc20Provider = void 0;
      var o = n(r(759));
      t.EthereumErc20Provider = o.default;
    },
    746: function _(e) {
      e.exports = require("@liquality/crypto");
    },
    754: function _(e) {
      e.exports = require("@liquality/errors");
    },
    742: function _(e) {
      e.exports = require("@liquality/ethereum-utils");
    },
    240: function _(e) {
      e.exports = require("@liquality/provider");
    },
    275: function _(e) {
      e.exports = require("@liquality/types");
    },
    463: function _(e) {
      e.exports = require("@liquality/utils");
    }
  },
      t = {},
      r = function r(n) {
    var o = t[n];
    if (void 0 !== o) return o.exports;
    var a = t[n] = {
      exports: {}
    };
    return e[n].call(a.exports, a, a.exports, r), a.exports;
  }(175);

  module.exports = r;
})();